export const getStatusColor = (status: string): string => {
    switch (status) {
        case 'Ativo':
            return 'green'; // azul pastel
        case 'Inativo':
            return 'red'; // laranja pastel
        case 'Sim':
            return 'green'; // azul pastel
        case 'Não':
            return 'red'; // laranja pastel
        default:
            return 'gray'; // Cor padrão para status desconhecido
    }
};

export const getResponsiveColor = (status: string): string => {
    switch (status) {
        case 'Web':
            return 'blue'; // azul pastel
        case 'Responsivo':
            return 'purple'; // laranja pastel
        default:
            return 'gray'; // Cor padrão para status desconhecido
    }
};

export const getOrderStatusColor = (status: string): string => {
    switch (status) {
        case 'ANALYSIS':
            return '#A7C7E7'; // Azul claro - representa análise e observação
        case 'BILLED':
            return '#FFE0B2'; // Laranja pastel - representa fatura e alerta suave
        case 'SENT':
            return '#D1C4E9'; // Roxo claro - envio, transição
        case 'PENDING_PAYMENT':
            return '#FFF9C4'; // Amarelo pastel - pendente, atenção
        case 'DELIVERED':
            return '#C8E6C9'; // Verde claro - sucesso leve, entrega
        case 'FINISHED':
            return '#A5D6A7'; // Verde pastel mais forte - finalizado com sucesso
        case 'PAID':
            return '#FFCCBC'; // Coral suave - representa pagamento, calor
        case 'PENDING':
            return '#FFF3E0'; // Laranja amarelado claro - algo em espera
        case 'CANCELED':
            return '#FFCDD2'; // Vermelho claro - cancelamento sem agressividade
        case 'RETURNED':
            return '#F8BBD0'; // Rosa pastel - retorno, delicado
        case 'CAPTURED':
            return '#E1BEE7'; // Lilás claro - captura com neutralidade
        case 'ACCEPTED':
            return '#B3E5FC'; // Azul bebê - aceitação, tranquilidade
        case 'AUTHORIZED':
            return '#DCEDC8'; // Verde limão pastel - autorização positiva
        default:
            return '#E0E0E0'; // Cinza claro - neutro para status desconhecido
    }
};


export const getOrderBonusStatusColor = (status: string): string => {
    switch (status) {
        case 'PENDING':
            return '#A7C7E7'; // Azul claro - representa análise e observação
        case 'APPROVED':
            return '#C8E6C9'; // Verde claro - sucesso leve, entrega
        case 'DECLINED':
            return '#FFCDD2'; // Vermelho claro - cancelamento sem agressividade
        default:
            return '#A7C7E7'; // Cinza claro - neutro para status desconhecido
    }
};